const numberPattern = /[-]{0,1}[\d]*[.]{0,1}[\d]+/g;
export const parsePrice = (value) =>
  value && parseFloat(value.match(numberPattern).join(""));
